// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__CefNh","location":"Header_location__S9sUk"};